import { render, staticRenderFns } from "./BetslipStakeBox.vue?vue&type=template&id=66bec19e&scoped=true"
import script from "./BetslipStakeBox.vue?vue&type=script&lang=js"
export * from "./BetslipStakeBox.vue?vue&type=script&lang=js"
import style0 from "./BetslipStakeBox.vue?vue&type=style&index=0&id=66bec19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bec19e",
  null
  
)

export default component.exports